export interface IParkingPlace {
    id: number;
    description: string;
    price: number | null;
    quantity: number | null;
    type: number;
}

export enum ParkingPlacesType {
    UNDERGROUND = 1,
    GROUND = 2
}
export interface IParkingPlace {
    id: number;
    description: string;
    price: number | null;
    quantity: number | null;
    type: number;
}

export enum ParkingPlacesType {
    UNDERGROUND = 1,
    GROUND = 2
}
